import React from 'react';
import { formatCurrency } from '@avila-tek/ui/src';
import { Client, ShopCartItem, ShopItem } from '../../../models';
import { TEditShopCartInput } from '../../../hooks';
import ItemQuantity from './ItemQuantity';
import EditEmployeeItem from './EditEmployeeItem';

interface ShopcartItemProps {
  title: string;
  subtitle: string;
  price: number;
  quantity: number;
  clients: ShopItem[];
  editShopCart: (input: TEditShopCartInput) => void;
  shopCartItem: ShopCartItem;
  type: 'product' | 'plan' | 'benefit';
}

function ShopcartItem({
  title,
  subtitle,
  price,
  quantity,
  clients,
  editShopCart,
  shopCartItem,
  type,
}: ShopcartItemProps) {
  const [isCollapse, setIsCollapse] = React.useState(false);

  const totalByItem = React.useMemo(() => {
    if (type === 'benefit') {
      return shopCartItem.shopList.reduce(
        (acc, cur) => acc + cur.quantity * shopCartItem.price,
        0
      );
    }
    return shopCartItem.shopList.reduce(
      (acc, cur) => acc + cur.quantity * shopCartItem.price,
      0
    );
  }, [shopCartItem]);

  return (
    <div className="py-5 border-b border-neutral-cold-200 r">
      <div className="flex flex-col sm:flex-row items-center">
        <div className="flex flex-col space-y-1 ">
          <span className="font-semibold text-text-black text-lg">{title}</span>
          <span className="text-neutral-warm-500">{subtitle}</span>
          <button
            className="flex text-neutral-warm-500 font-semibold"
            type="button"
            onClick={() => setIsCollapse(!isCollapse)}
          >
            <div className="flex items-center gap-5">
              Ver beneficiarios
              <div className="border border-purple-100 bg-purple-50 text-purple-300 font-semibold rounded py-1 px-2 text-sm">
                {isCollapse ? 'Ocultar' : 'Editar'}
              </div>
            </div>
          </button>
        </div>
        {type !== 'benefit' ? (
          <div className="sm:ml-auto flex">
            <ItemQuantity canEdit={false} price={price} quantity={quantity} />
          </div>
        ) : null}
        <div className="sm:ml-auto flex">
          <span className="text-text-black">
            ${formatCurrency(totalByItem)}
          </span>
        </div>
        <div />
      </div>
      <div />
      <div>
        {isCollapse
          ? clients.map((item, i) => (
              <EditEmployeeItem
                key={`${(item.client as Client)?.user}-${i}`}
                user={(item.client as Client)?.user}
                type={type}
                editShopCart={editShopCart}
                shopItem={shopCartItem}
                quantity={item?.quantity ?? 0}
                price={shopCartItem.price}
              />
            ))
          : null}
      </div>
    </div>
  );
}

export default ShopcartItem;
